export * from "./user.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/user/index.ts